import React from 'react'
import { Box, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react'
import { MICROSITE_THEME_DEFAULT_PALETTE } from './microsite/micrositeUtils'

const TEMPLATES = [
  { id: 'moderno', name: 'Moderno', layout: 'hero' },
  { id: 'clasico', name: 'Clásico', layout: 'compact' },
  { id: 'elegante', name: 'Elegante', layout: 'split' },
  { id: 'aurora', name: 'Aurora', layout: 'dark' },
  { id: 'editorial', name: 'Editorial', layout: 'columns' },
  { id: 'pulso', name: 'Pulso', layout: 'brutal' },
  { id: 'vortex', name: 'Vortex', layout: 'dark' },
  { id: 'glass', name: 'Glass', layout: 'frost' },
  { id: 'kinetic', name: 'Kinetic', layout: 'contrast' },
]

const Thumb = ({ layout, pal }) => {
  const { primario, secundario, fondo } = pal
  const frame = { w: 'full', aspectRatio: '4 / 3' }

  if (layout === 'split') {
    return (
      <Box {...frame} display="flex">
        <Box flex={1} bg={secundario} />
        <Box flex={1} bg={fondo} display="flex" alignItems="center" justifyContent="center">
          <Box w="28%" aspectRatio={1} rounded="full" bg={primario} opacity={0.85} />
        </Box>
      </Box>
    )
  }
  if (layout === 'compact') {
    return (
      <Box {...frame} bg={fondo}>
        <Box h="34%" bg={secundario} />
        <Box h="66%" display="flex" alignItems="center" justifyContent="center">
          <Box w="22%" aspectRatio={1} rounded="full" bg={primario} />
        </Box>
      </Box>
    )
  }
  if (layout === 'columns') {
    return (
      <Box {...frame} bg={fondo} display="flex">
        <Box w="8px" bg={primario} />
        <Box flex={1} p={2}>
          <Box h="18%" w="70%" bg={secundario} opacity={0.35} mb={2} />
          <Box h="10%" w="90%" bg={secundario} opacity={0.15} mb={1} />
          <Box h="10%" w="60%" bg={secundario} opacity={0.15} />
        </Box>
      </Box>
    )
  }
  if (layout === 'brutal') {
    return (
      <Box {...frame} bg={fondo} borderWidth="3px" borderColor={secundario}>
        <Box h="40%" bg={primario} />
        <Box p={2}>
          <Box h="8px" w="80%" bg={secundario} mb={1.5} />
          <Box h="6px" w="50%" bg={secundario} opacity={0.4} />
        </Box>
      </Box>
    )
  }
  if (layout === 'frost') {
    return (
      <Box {...frame} bg={fondo} position="relative">
        <Box position="absolute" inset="18% 12%" bg="white" opacity={0.7} rounded="md" borderWidth="1px" borderColor={primario} />
        <Box position="absolute" top="22%" left="18%" right="18%" h="8px" bg={primario} opacity={0.8} />
      </Box>
    )
  }
  if (layout === 'contrast') {
    return (
      <Box {...frame} bg={fondo} position="relative" overflow="hidden">
        <Box position="absolute" left="-20%" top="-10%" w="70%" h="140%" bg={secundario} transform="rotate(-18deg)" />
        <Box position="absolute" bottom={3} right={3} w="28%" h="10px" bg={primario} />
      </Box>
    )
  }
  if (layout === 'dark') {
    return (
      <Box {...frame} bg={fondo} position="relative" overflow="hidden">
        <Box position="absolute" top="-20%" right="-12%" w="55%" aspectRatio={1} rounded="full" bg={primario} opacity={0.35} />
        <Box position="absolute" bottom={4} left={3} right="30%" h="8px" bg={primario} />
        <Box position="absolute" bottom={7} left={3} w="40%" h="5px" bg={secundario} />
      </Box>
    )
  }
  return (
    <Box {...frame} bg={secundario} position="relative">
      <Box position="absolute" inset={0} bg={primario} opacity={0.55} />
      <Box position="absolute" inset={0} display="flex" alignItems="center" justifyContent="center">
        <Box w="22%" aspectRatio={1} rounded="full" bg="white" opacity={0.35} />
      </Box>
    </Box>
  )
}

const MicrositeTemplateGallery = () => (
  <Box id="plantillas-web" pt={{ base: 4, md: 6 }}>
    <VStack gap={3} textAlign="center" mb={8}>
      <Heading as="h3" fontSize={{ base: 'xl', md: '2xl' }} color="gray.800">
        Nueve plantillas para Tu Web
      </Heading>
      <Text color="gray.600" maxW="2xl" fontSize="md">
        Elige el aspecto de la web pública de la agrupación. El dominio propio va con el plan Avanzado.
      </Text>
    </VStack>
    <SimpleGrid
      columns={{ base: 2, md: 3 }}
      gap={{ base: 4, md: 6 }}
      w="full"
      maxW="5xl"
      mx="auto"
    >
      {TEMPLATES.map((tpl) => (
        <VStack key={tpl.id} gap={2} align="stretch" minW={0}>
          <Box
            rounded="xl"
            overflow="hidden"
            borderWidth="1px"
            borderColor="gray.200"
            bg="white"
            shadow="sm"
          >
            <Thumb layout={tpl.layout} pal={MICROSITE_THEME_DEFAULT_PALETTE[tpl.id]} />
          </Box>
          <Text fontSize="xs" fontWeight="700" color="gray.700" textAlign="center">
            {tpl.name}
          </Text>
        </VStack>
      ))}
    </SimpleGrid>
  </Box>
)

export default MicrositeTemplateGallery
